import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from './currency.pipe';

@Pipe({
    name: 'scCurrencyWithDecimals'
})
export class CurrencyWithDecimalsPipe implements PipeTransform {

    constructor(private currencyPipe: CurrencyPipe) { }

    transform(val: number): string {
        const decimals = val.toString().split('.').length >= 2 ? val.toString().split('.')[1].slice(0,2) : '00';
        return `${val.toString().includes('-') ? '-' : ''}$ ${this.currencyPipe.addThousandsSeparator(val.toString().replace('-', '').split('.')[0], '.')},${decimals.padEnd(2, '0')}`;
    }
}
